import { MenuItem, Select, Typography } from "@mui/material";
import React from "react";
import { languagesAvailableInConfig } from "./translations_definitions";

export function LanguageSelect({
  onChange,
  language,
  allowedLanguages,
}: {
  language: string;
  allowedLanguages: string[];
  onChange: (event: React.ChangeEvent<{ name?: string | undefined; value: unknown }>) => void;
}) {
  const activeLanguages = languagesAvailableInConfig.filter((l) => allowedLanguages.includes(l.value));

  return (
    <Select onChange={(e) => onChange(e)} sx={{ height: "fit-content" }} value={language}>
      {activeLanguages.map(({ value, flag }, idx) => {
        return (
          <MenuItem key={idx} value={value}>
            <Typography component={"span"} sx={{ display: "flex", alignItems: "center", gap: 1, height: "1.4375em" }}>
              <img alt={`flag of country ${value}`} src={flag} style={{ height: "1em" }} /> {value}
            </Typography>
          </MenuItem>
        );
      })}
    </Select>
  );
}
